// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"VideoModal_videoContainer__29xc0","videoFrame":"VideoModal_videoFrame__138pn"};